import BaseAPI from './base'

class TeacherGiftCardAPI extends BaseAPI {}

export default new TeacherGiftCardAPI('v1/teacher-gift-card', 'TeacherGiftCard')
